import parseDateTime from '../parseDateTime';

import { Dateable } from '../types';

// Takes a Date or string to convert to one
// Dates are always localized
// Returned Date is as well, but acts like it's UTC
const getUTCDate = (dateTime: Dateable): Date => {
  const parsedDate = parseDateTime(dateTime);
  const utcDate = new Date(
    parsedDate.getUTCFullYear(),
    parsedDate.getUTCMonth(),
    parsedDate.getUTCDate(),
    parsedDate.getUTCHours(),
    parsedDate.getUTCMinutes(),
    parsedDate.getUTCSeconds(),
    parsedDate.getUTCMilliseconds()
  );
  return utcDate;
};

export default getUTCDate;
